import { render, staticRenderFns } from "./LastItem.vue?vue&type=template&id=6192a912&scoped=true"
import script from "./LastItem.vue?vue&type=script&lang=js"
export * from "./LastItem.vue?vue&type=script&lang=js"
import style0 from "./LastItem.vue?vue&type=style&index=0&id=6192a912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6192a912",
  null
  
)

export default component.exports